<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Add Corporate</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <AddNewCorporate />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import AddNewCorporate from "@/components/admin/addNewCorporate.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'addNewCorporate',
    components: {
      AddNewCorporate, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {
            add
        }
    },
    methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
  }
})
</script>